/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Kantor_S5Inputs */

const en_tut_kantor_s5 = /** @type {(inputs: Tut_Kantor_S5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When you are done, press **Keluar kantor**.`)
};

const id_tut_kantor_s5 = /** @type {(inputs: Tut_Kantor_S5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selesai bekerja, tekan **Keluar kantor**.`)
};

/**
* | output |
* | --- |
* | "When you are done, press **Keluar kantor**." |
*
* @param {Tut_Kantor_S5Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_kantor_s5 = /** @type {((inputs?: Tut_Kantor_S5Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Kantor_S5Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_kantor_s5(inputs)
	return en_tut_kantor_s5(inputs)
});